const SET_FOCUS_SIDE = 'setFocusSide';
const SET_SIDE_REF = 'setSideRef';
const SET_SIDE_TRANS_STATUS = 'setSideTransStatus';
const SET_DUAL_VIEW_SETTING = 'setDualViewSetting';

const state = {
    focus: 'left',
    refs: {
        left: undefined,
        right: undefined
    },
    sideTransStatus: {
        left: false,
        right: false
    },
    dualViewSetting: {
        left: [],
        right: []
    }
};

const mutations = {
    [SET_FOCUS_SIDE](state, side) {
        state.focus = side;
    },
    [SET_SIDE_REF](state, { side, ref }) {
        state.refs = { ...state.refs };
        state.refs[side] = ref;
    },
    [SET_SIDE_TRANS_STATUS](state, { side, val }) {
        state.sideTransStatus = { ...state.sideTransStatus };
        if (side) {
            state.sideTransStatus[side] = val;
        } else {
            state.sideTransStatus.left = val;
            state.sideTransStatus.right = val;
        }
    },
    [SET_DUAL_VIEW_SETTING](state, setting) {
        state.dualViewSetting = setting;
    }
};

const getters = {
    focusOnSide: ({ focus }) => focus,
    leftRef(state) {
        return state.refs.left;
    },
    rightRef(state) {
        return state.refs.right;
    },
    leftTransStatus(state) {
        return state.sideTransStatus.left;
    },
    rightTransStatus(state) {
        return state.sideTransStatus.right;
    },
    sideTransStatus(state) {
        return state.sideTransStatus;
    },
    dualViewSetting: state => state.dualViewSetting
};

const actions = {
    setDualFocusSide({ commit }, side) {
        commit(SET_FOCUS_SIDE, side);
    },
    setDualSideRef({ commit }, { side, ref }) {
        commit(SET_SIDE_REF, { side, ref });
    },
    cleanDualSideRef({ commit }) {
        commit(SET_SIDE_REF, 'left', undefined);
        commit(SET_SIDE_REF, 'right', undefined);
    },
    setSideTransStatus({ commit }, { side, val }) {
        commit(SET_SIDE_TRANS_STATUS, { side, val });
    },
    setDualViewSetting({ commit }, setting) {
        commit(SET_DUAL_VIEW_SETTING, setting);
    }
};

export default {
    state,
    mutations,
    getters,
    actions
};
